import React from "react";
import PropTypes from "prop-types";
import "./title-right-section.style.scss";

export const TitleRightSection = props => (
  <div className="section-wrapper d-flex float-right">
    {props.items.map((item, index) => (
      <div className="section-item" key={index}>
        {item}
      </div>
    ))}
  </div>
);

TitleRightSection.propTypes = {
  items: PropTypes.array.isRequired,
};

export default TitleRightSection;
